const MESSAGE_TYPE = {
	// 正常消息类型（与后端 msg_inner_struct.go 一致）
	SYS: 0,           // 系统消息
	TEXT: 1,          // 文本消息
	IMAGE: 2,         // 图片消息
	GIF: 3,           // GIF消息
	FILE: 4,          // 文件消息
	VIDEO: 5,         // 视频消息
	VOICE: 6,         // 语音消息
	CARD: 7,          // 名片消息
	MICRO_PROGRAM: 8, // 小程序
	VIDEO_CHANNEL: 9, // 视频号
	LINK: 10,         // 图文链接
	LOCATION: 11,     // 位置消息
	TEXT_MOON: 12,    // 文本表情
	AT: 14,           // @消息
	GROUP_AT: 15,     // 群@消息
	MERGE: 16,        // 合并消息
	
	// 系统通知类型
	FRIEND_DELETE_NOTIFY: 100, // 好友删除通知
	FRIEND_BLACK_TYPE: 101,    // 好友拉黑通知
	FRIEND_DELETED_TYPE: 102,  // 被好友删除通知
	
	// 状态消息（前端扩展，200+ 避免与后端消息类型冲突）
	RECALL: 200,      // 消息撤回
	READED: 201,      // 消息已读
	RECEIPT: 202,     // 消息回执
	
	// 提示消息（前端扩展）
	TIP_TIME: 20,     // 时间提示
	TIP_TEXT: 21,     // 文本提示
	LOADING: 30,      // 加载中
	USER_BANNED: 50,  // 用户被封禁
	
	// 好友/群组事件（前端扩展）
	FRIEND_NEW: 80,   // 新增好友
	FRIEND_DEL: 81,   // 删除好友
	FRIEND_DND: 82,   // 好友免打扰
	GROUP_NEW: 90,    // 新增群组
	GROUP_DEL: 91,    // 删除群组
	GROUP_DND: 92     // 群组免打扰
}

const TERMINAL_TYPE = {
	WEB: 0,
	APP: 1
}

const MESSAGE_STATUS = {
	FAILED: -2, // 发送失败
	SENDING: -1, // 发送中(消息没到服务器)
	PENDING: 0, // 未送达(消息已到服务器，但对方没收到)
	DELIVERED: 1, // 已送达(对方已收到，但是未读消息)
	RECALL: 2, // 已撤回
	READED: 3, // 消息已读
}

export {
	MESSAGE_TYPE,
	TERMINAL_TYPE,
	MESSAGE_STATUS
}